import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import nbaLogo from '../../images/nba_login.png';
import nbca_splash from '../../images/nbca_splash.png';
import RouteConstants from '../../common/RouteConstants';

import useForm from '../../sharedComponents/customHooks/useForm';
import Loader from '../../sharedComponents/Loader/Loader';
import { AppDataContext } from "../../common/AppContext";

import { authenticationService, userService } from '../../services';

import { UserProfileContext } from "../../common/ProfileContext";
import { Role } from '../../helper';


import './CoachLogin.css';
import { addOpacity, darkenColor } from '../../utils/appHelper';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        ...theme.palette.mode === 'dark' && {backgroundColor: theme.palette.background.default}
    },
    logoStrip: {
        display: 'flex',
        // flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'start',
        width: '100%',
        height: '150px',
        ...theme.palette.mode === 'dark' && {backgroundColor: darkenColor(theme.palette.background.default, 10)},
        // paddingTop: '7%'
    },
    logo: {
        [theme.breakpoints.up('sm')]: {
            width: '425px',
            height: '170px'
        },
        [theme.breakpoints.down('md')]: {
            height: '83px',
            width: '260px'
        },
    },
    loginBox: {
        width: '280px',
        position: 'fixed',
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.spacing(1.5),
        [theme.breakpoints.up('lg')]: {
            right: '10%',
            alignSelf: 'flex-end',
            height: '320px',
        },
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'center',
            height: '385px',
            position: 'static',
            margin: theme.spacing(2),
        },
    },
    sectiondivider: {
        margin: theme.spacing(1)
    },
    nbaLogo: {
        width: '50px',
        paddingLeft: '10.5%',
        paddingRight: '2.5rem',
    },
    nbcaSplashLogo: {
        width: '100px',
        paddingLeft: '30px',
    }
}));

const CoachLogin = (props) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        setProfileContext
    } = useContext(UserProfileContext);

    useEffect(() => {
        if (authenticationService.currentUserValue) {
            let user = authenticationService.currentUserValue;
            returnToRedirect(user);
        }
    }, []);

    let initialState = { username: '', password: '' };

    const [state, setState] = useState(initialState);

    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const onChange = () => {
    }


    const { errors, handleInputChange, values } = useForm(state, onChange, props.validationSchema);

    const keyPress = (e) => {
        if (e.keyCode == 13) {
            handleLoginClick();
        }
    }

    function returnToRedirect(user) {
        let userRole = userService.getUserRole();
        let path = location.state?.from?.pathname || "";

        if (path != "") {
            navigate(path);
        }
        // else if (user && user.termsAccepted && user.termsAccepted == true && userRole === Role.Coach) {
        //     const { from } = props.location.state || { from: { pathname: RouteConstants.COACH_PROFILE_VIEW } };
        //     props.history.push(from);
        // }
        else if (user && user.termsAccepted && user.termsAccepted == true) {
            if (user && userRole && (userRole == Role.FrontOffice || userRole == Role.FrontOfficePlusCoach)) {
                const { from } = { from: { pathname: RouteConstants.ACTIVE_SHOWCASE } };
                navigate(from.pathname);
            }
            else if (user && userRole && userRole == Role.Admin) {
                const { from } = { from: { pathname: RouteConstants.COACH_MANAGEMENT } };
                navigate(from.pathname);
            }
            else {
                const { from } = location.state || { from: { pathname: RouteConstants.COACH_PROFILE_VIEW } };
                navigate(from.pathname);
            }
        }
        else {
            const { from } = { from: { pathname: RouteConstants.TERMS_AND_CONDITIONS } };
            navigate(from.pathname);
        }
    }

    const handleLoginClick = () => {
        //validate user
        setIsLoading(true);
        authenticationService.login(values.username, values.password)
            .then(user => {
                if (!user) {
                    setIsLoading(false);
                    setErrorMsg('Incorrect credentials. Please try again.');
                    setShowError(true);
                }
                else {
                    document.cookie = `HangFireCookie=${user.token};Path=/`;
                    setIsLoading(false);
                    setShowError(false);
                    returnToRedirect(user);
                }
            },
                error => {
                    setIsLoading(false);
                    setErrorMsg('Incorrect credentials. Please try again.');
                    if (error == "inactive") {
                        setErrorMsg('Your account is inactive.');
                    }
                    setShowError(true);
                    //console.log(error);
                }
            );
    }

    // const gotoSignup = () => {
    //     props.history.push(RouteConstants.COACH_REGISTRATION);
    // }

    const gotoForgotPassword = () => {
        navigate(RouteConstants.FORGOT_PASSWORD);
    }

    const gotoForgotUsername = () => {
        navigate(RouteConstants.FORGOT_USERNAME);
    }

    const gotoPrivacyPolicy = () => {
        navigate(RouteConstants.PRIVACY_POLICY);
    }

    return (
        <div className={clsx("login-bg", classes.root)}>
            <Box sx={{ width: '100%', flex: 2 }}>
                <div style={{ flex: 2 }}></div>
            </Box>
            <Box sx={{ width: '100%', flexShrink: 0 }}>
                <div className={clsx("login-strip-bg", classes.logoStrip)}>
                    {/* <img src={nbaLogo} className={classes.nbaLogo} /> */}
                    <p className={clsx("appTitle")}>NBA Coaches Database</p>
                </div>
            </Box>
            <Box sx={{ width: '100%', flex: 2, display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingTop: '8rem' }}>
                    <img src={nbaLogo} className={classes.nbaLogo} />
                    <img src={nbca_splash} className={classes.nbcaSplashLogo} />
                </div>
            </Box>

            <Paper className={classes.loginBox} elevation={10}>
                <Typography variant="h5" color="secondary">Welcome</Typography>
                <div className={classes.sectiondivider}></div>
                <div className={classes.sectiondivider}></div>
                <TextField variant="outlined"
                    id="coachUsername"
                    size="small"
                    label="Username"
                    name="username"
                    onChange={handleInputChange}
                    fullWidth
                    autoFocus
                    onKeyDown={keyPress}
                />
                <div className={classes.sectiondivider}></div>
                <TextField
                    type="password"
                    id="coachPassword"
                    variant="outlined"
                    size="small"
                    name="password"
                    onChange={handleInputChange}
                    label="Password" fullWidth
                    onKeyDown={keyPress}
                />
                <div className={classes.sectiondivider}></div>
                {showError &&
                    <>
                        <Typography color="error">{errorMsg}</Typography>
                        <div className={classes.sectiondivider}></div>
                    </>
                }
                <Button color="secondary" disabled={isLoading} variant="contained" fullWidth onClick={handleLoginClick} className="capitalize">Login</Button>

                <div className={classes.sectiondivider}></div>

                <Button className="forgot-link" variant="text" onClick={gotoForgotUsername}>
                    <Typography variant="caption" style={{ cursor: 'pointer' }}>Forgot Username</Typography></Button>

                <Button className="forgot-link" variant="text" onClick={gotoForgotPassword}>
                    <Typography variant="caption" style={{ cursor: 'pointer' }}>Forgot Password</Typography></Button>
                <Button className="forgot-link" variant="text" onClick={gotoPrivacyPolicy}>
                    <Typography variant="caption" style={{ cursor: 'pointer' }}>Privacy Policy</Typography></Button>

                {/* <Button className="create-btn" variant="text" onClick={gotoSignup}>
                    <Typography variant="caption" style={{ cursor: 'pointer' }}>Create New Account
                    </Typography>
                </Button> */}
                <Loader isLoading={isLoading} />
            </Paper>
        </div>
    );
}

export default CoachLogin;